<div class="filters-modal">
    <header class="filters-modal__header">
        <div class="filters-modal__copy">
            <span class="filters-modal__eyebrow">Búsqueda avanzada</span>
            <h2>Filtra terapeutas por perfil y disponibilidad</h2>
            <p>Refina la lista por nombre, género y rango de horario sin salir del flujo actual.</p>
        </div>

        <button mat-icon-button type="button" class="filters-modal__close" (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <section class="filters-modal__section filters-modal__section--compact">
        <div class="filters-field">
            <label class="filters-field__label" for="filters-name">Nombre del terapeuta</label>
            <mat-form-field appearance="outline" class="filters-field__control">
                <input matInput id="filters-name" [(ngModel)]="nombre" placeholder="Ej. María, David, Lucía">
            </mat-form-field>
        </div>

        <div class="filters-field">
            <label class="filters-field__label">Género</label>
            <mat-radio-group aria-label="Genero" [(ngModel)]="genero" color="primary" class="filters-chip-group">
                <mat-radio-button value="female">Femenino</mat-radio-button>
                <mat-radio-button value="male">Masculino</mat-radio-button>
            </mat-radio-group>
        </div>
    </section>

    <section class="filters-modal__section">
        <div class="filters-section__heading">
            <div>
                <h3>Disponibilidad</h3>
                <p>Selecciona uno o varios días y define el rango horario que quieres consultar.</p>
            </div>
        </div>

        <div class="filters-scheduler">
            <article class="filters-panel">
                <div class="filters-panel__header">
                    <div>
                        <span class="filters-panel__eyebrow">Fecha</span>
                        <h4>Calendario</h4>
                    </div>
                    <span class="filters-panel__badge">{{ daysSelected.length || 0 }} día(s)</span>
                </div>

                <mat-calendar
                    class="calendar"
                    #calendar
                    [minDate]="minDate"
                    (selectedChange)="select($event,calendar)"
                    [dateClass]="isSelected">
                </mat-calendar>
            </article>

            <article class="filters-panel filters-panel--time">
                <div class="filters-panel__header">
                    <div>
                        <span class="filters-panel__eyebrow">Hora</span>
                        <h4>Rango de atención</h4>
                    </div>
                </div>

                <div class="time-range">
                    <div class="time-range__row">
                        <label for="inputInicio">Inicio</label>
                        <div class="time-range__control">
                            <select class="form-control" [(ngModel)]="horaInicio" id="inputInicio">
                                <option *ngFor="let h of horas">{{ h }}</option>
                            </select>
                        </div>
                        <div class="time-range__toggle">
                            <span>AM</span>
                            <mat-slide-toggle [(ngModel)]="horaInicioIsPm" aria-label="Periodo inicio">PM</mat-slide-toggle>
                        </div>
                    </div>

                    <div class="time-range__row">
                        <label for="inputFin">Final</label>
                        <div class="time-range__control">
                            <select class="form-control" [(ngModel)]="horaFin" id="inputFin">
                                <option *ngFor="let h of horas">{{ h }}</option>
                            </select>
                        </div>
                        <div class="time-range__toggle">
                            <span>AM</span>
                            <mat-slide-toggle [(ngModel)]="horaFinIsPm" aria-label="Periodo fin">PM</mat-slide-toggle>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    </section>

    <footer class="filters-modal__footer">
        <button
            mat-button
            type="button"
            class="filters-modal__clear"
            (click)="clearFilters()"
            matTooltip="Quita los filtros y vuelve a mostrar todos los terapeutas de esta categoría"
        >
            Limpiar filtros
        </button>
        <button mat-flat-button color="primary" type="button" class="filters-modal__submit" (click)="buscar()">
            Buscar terapeutas
        </button>
    </footer>
</div>
